import React, { Component } from 'react';
import { Link, NavWrapper, LinkWrapper, Logo, LinkWrapperFixed, Icon, IconClose } from './components';
import { Responsive } from '../';
import { animeLogo } from '../../img';

class Navigation extends Component {
	state = {
		visible: false,
	}

	render() {
		const items = this.props.items;
		return (
			<span>
				<Responsive.Desktop>
					<NavWrapper>
						<Logo src={animeLogo} />
						<LinkWrapper>
							{items.map((item) => {
								return <Link key={item.link} href={item.link}>{item.name}</Link>
							})}
						</LinkWrapper>
					</NavWrapper>
				</Responsive.Desktop>
				<Responsive.Mobile>
					<NavWrapper>
						<Logo src={animeLogo} />
						<LinkWrapper>
							<Icon name="bars" onClick={() => this.setState({visible: true})}/>
						</LinkWrapper>
						<LinkWrapperFixed visible={this.state.visible}>
							<IconClose name="times" onClick={() => this.setState({visible: false})}/>
							{items.map((item) => {
								return <span><Link key={item.link} href={item.link} mobile onClick={() => this.setState({visible: false})}>{item.name}</Link><br /></span>
							})}
						</LinkWrapperFixed>
					</NavWrapper>
				</Responsive.Mobile>
			</span>
			
		);
	}
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/navigation/index.js